import React, { useState, useReducer, useEffect, useContext } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { Paper, Typography } from "@material-ui/core";
import { formatMoney } from '../helpers/constants';



export default function PriceCard(props) {

    const state = useContext(AppContext);
    const s = state.strings;

    const { title, text1, text2, text3, price, taxIncluded, vatRate, currency, color, selected, productId, handleChange } = props;
    const useStyles = makeStyles((theme) => ({
      root: {
        cursor: "pointer",
        height: 230,
        width: 155,
        padding: theme.spacing(1),
        transition: "background-color 0.4s",
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
        "&:hover": {
          backgroundColor: '#eeeeee',
          boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.3)",
          transition: "background-color 0.4s",
        }
      }
    }));
    const classes = useStyles();
  
    const priceVAT = formatMoney((taxIncluded) ? price : (price / (1.0 + ((vatRate || 19) / 100.0))));
  
  
    return (
      <Paper className={classes.root} onClick={() => { handleChange && handleChange(productId) }} style={{ backgroundColor: (selected) ? "#BCDBF6" : color }}>
        <Typography paragraph align="center" color="primary" variant="h6">{title}</Typography>
        <Typography paragraph align="center" variant="body1">{text1}</Typography>
        <Typography align="center" variant="body2">{text2}</Typography>
        <Typography paragraph bottomGutter align="center" variant="body2">{text3}</Typography>
        <Typography align="center" variant="body2">{currency} {taxIncluded ? s.paymentDialog.inclVAT : s.paymentDialog.exclVAT}</Typography>
        <Typography align="center" color="secondary" variant="h4">{priceVAT}</Typography>
      </Paper>
    );
  }
  